module.exports = __webpack_public_path__ + "img/across front.8d381ebd.png";